import State from "slotworks/state-machine/states/state";
import gameState from "slotworks/model/game-state";
import Bet from "slotworks/model/bets/bet-model";
import Components from "slotworks/components/components";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import Contract from "slotworks/utils/contract";
import DSComponents from "components/components";

export default class BonusWin extends State {

    public onEnter() {
        this.complete(); 
    }

}